import barracudaStatus from '../components/barracuda_status';

export default {
  init() {
    // JavaScript to be fired on all pages
    if ($('.barracuda-status').length) {
      barracudaStatus($('.barracuda-status').data('domain'));
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/clientareaproductdetails.js